import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';

const AllVideos = () => {
    const theme = useContext(ThemeContext);
    return ( 
        <div className="videos" style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
            <h2>Videos Coming Soon...</h2>
        </div>
     );
}
 
export default AllVideos;